import React from "react"
import { connect } from "react-redux"
import * as ItemTypes from "../../redux/items/types"
import { Button } from "react-bootstrap"
import { DckActionCreators, DckSelectors } from "dck-redux"
import processTypes from "../../redux/processes/types"
import FontAwesome from "react-fontawesome"
import AgeModalForm from './AgeModalForm'

class AddAgeSettingForm extends React.Component {
 
  state = {
    show: false,
    countryCode: '',
    min: '',
    max: '',
  }

  /**
   * Show the Modal form
   */
  handleShow = () => this.setState({ show: true })

  /**
   * Close the modal form
   */
  handleClose = () => {
    this.props.loadAgeSettings()
    this.setState({ show: false })
  }

  render() {
    const { countryCode, max, min, show } = this.state,
    { addAgeSetting, isProcessRunning, isProcessSuccessful, isProcessFailed, processResult } = this.props

    return (
      <div>

        <Button className="circular-btn" bsStyle="primary" bsSize="small" onClick={ this.handleShow }>
          <FontAwesome name='plus' size="lg"/> New
        </Button>

        <AgeModalForm
          show={ show }
          handleClose={ this.handleClose }
          saveAgeSetting={ addAgeSetting }

          isUpdate={ false }
          title='New Age Setting'
          buttonText='Save'

          countryCode={ countryCode }
          setCountryCode={countryCode => this.setState({ countryCode }) }

          min={ min }
          setMin={min => this.setState({ min })}

          max={ max }
          setMax={max => this.setState({ max })}

          running={ isProcessRunning }
          success={ isProcessSuccessful }
          error={ isProcessFailed ? processResult.result.text : null }
          />
      </div>
    )
  }
}

const mapStateToProps = state => {

  const isProcessRunning = DckSelectors.selectProcessRunning(
    state,
    processTypes.SAVE_AGE_SETTING
  ),

  isProcessFailed = DckSelectors.selectProcessFailed(
    state,
    processTypes.SAVE_AGE_SETTING
  ),

  isProcessSuccessful = DckSelectors.selectProcessSuccess(
    state,
    processTypes.SAVE_AGE_SETTING
  ),

  processResult = DckSelectors.selectProcess(
    state, 
    processTypes.SAVE_AGE_SETTING
  )

  return { isProcessRunning, isProcessFailed, isProcessSuccessful, processResult }
},

mapDispatchToProps = dispatch => ({
  addAgeSetting: data => dispatch(DckActionCreators.itemAdd(ItemTypes.AgeSetting, data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddAgeSettingForm)



// WEBPACK FOOTER //
// ./src/components/Settings/AddAgeSettingForm.js